import { render, staticRenderFns } from "./PAOverview.vue?vue&type=template&id=6894b2bb"
import script from "./PAOverview.vue?vue&type=script&lang=js"
export * from "./PAOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports